import React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";

const borderColor = "#ccc";
const backColor = "#e6e7e8";
const styles = StyleSheet.create({
  live_intake_n: {
    width: "44%",
    height: 30,
    paddingTop: 7,
    backgroundColor: "#1f6165",
    borderColor: borderColor,
    borderWidth: 1,
    color: "white",
  },
  canine: {
    width: "10%",
    height: 30,
    paddingTop: 8,
    fontSize: 11,
    backgroundColor: backColor,
    borderColor: borderColor,
    borderWidth: 1,
  },
  feline: {
    width: "18%",
    height: 30,
    paddingTop: 8,
    fontSize: 11,
    backgroundColor: backColor,
    borderColor: borderColor,
    borderWidth: 1,
  },
  subtotal: {
    width: "18%",
    height: 30,
    paddingTop: 8,
    fontSize: 11,
    backgroundColor: backColor,
    borderColor: borderColor,
    borderWidth: 1,
  },
  total: {
    width: "10%",
    height: 30,
    paddingTop: 8,
    fontSize: 11,
    backgroundColor: backColor,
    borderColor: borderColor,
    borderWidth: 1,
  },
});

const SpecieTableHeader = (props) => (
  <View style={props.styles.container2}>
    <Text style={styles.live_intake_n}>{props.name}</Text>
    <Text style={styles.canine}>ADULTS</Text>
    <Text style={styles.feline}>UP TO 5 MONTHS</Text>
    <Text style={styles.subtotal}>AGE UNKNOWN</Text>
    <Text style={styles.total}>TOTAL</Text>
  </View>
);

export default SpecieTableHeader;
